import React from "react";

const SunriseIframeTest = () => {
  return (
    <div className="min-h-screen  p-6 md:p-1">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          {/* Header Section */}
          <div className="p-6 md:p-8 border-b border-gray-200">
            <h1 className="text-2xl font-bold text-gray-800 mb-2">
              Planpilot - Iframe
            </h1>
            <p className="text-sm text-slate-cloud mt-1">
              Direct view into the Planpilot built by Lysandro Marques & Neo
              Stutz
            </p>
          </div>

          {/* Iframe Container */}
          <div className="p-6 md:p-8 bg-gray-50">
            <div
              className="w-full bg-white rounded-2xl shadow-sm overflow-hidden"
              style={{ height: "800px" }}
            >
              <iframe
                src="https://planpilot.sunrise-avengers.ch/#calendar"
                title="PlanPilot Integration"
                width="100%"
                height="800"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SunriseIframeTest;
